module.exports = __webpack_public_path__ + "img/web-1.7b1a470d.png";